module.exports = __webpack_public_path__ + "img/star-map_backgrounds-black.00adb16.webp";